module.exports = __webpack_public_path__ + "static/giftcard-cutout-2c8810b8a6d9d0717d59aa48004ec7d0.png";